import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_METRICS;

function getEstadoFinanciero(param = {}) {
  return wsService.make_post_request(section + "/estado-financiero", param);
}

function getEstadoEconomico(param = {}) {
  return wsService.make_post_request(section + "/estado-economico", param);
}

function getEstadoImpositivo(param = {}) {
  return wsService.make_post_request(section + "/estado-impositivo", param);
}

export const metricsService = {
  getEstadoFinanciero,
  getEstadoEconomico,
  getEstadoImpositivo,
};
